export const openUrl = (url: string, target = '_blank', features = 'noreferrer noopener') => {
  if (!url) {
    return;
  }

  return window.open(url, target, features);
};
